import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { requirePermission } from '@/lib/auth/route-guards'
import type { RouterAuthContext } from '@/lib/auth/router-context'

export const Route = createFileRoute('/app/settings')({
  // Permission guard: requires settings view permission
  beforeLoad: async ({ context, location }) => {
    await requirePermission(context as RouterAuthContext, 'settings:view', {
      currentPath: location.pathname,
    })
  },

  component: lazyRouteComponent(() => import('./-settings')),
})
